import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { FaPlus } from "react-icons/fa";
import { Form, InputGroup, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { studyLevelFormManagementServices } from "../../../../APIServices/studyLevelFormManagementServices";

const AddEmailForNotify = ({
  getStudyLevelFieldCheckNotification,
  checkData,
}) => {
  const [emails, setEmails] = useState([]);
  let { studyId } = useParams();
  const [buttonLoader, setButtonLoader] = useState(false);
  const updateStudyLevelFieldCheckNotification = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Update Email for Field Notification!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.id = checkData?._id;
        userData.type = "email";
        userData.studyId = studyId;
        userData.emails = emails;
        let data =
          await studyLevelFormManagementServices.updateStudyLevelFieldCheckNotification(
            userData,
          );
        if (data?.statusCode === 200) {
          getStudyLevelFieldCheckNotification();
        }
      }
      setButtonLoader(false);
    });
  };

  const handleEmailChange = (index, value) => {
    const newEmails = [...emails];
    newEmails[index] = value;
    setEmails(newEmails);
  };

  const handleDeleteEmail = (index) => {
    const newEmails = [...emails];
    newEmails.splice(index, 1);
    setEmails(newEmails);
  };

  const handleAddEmail = () => {
    setEmails([...emails, ""]);
  };

  useEffect(() => {
    setEmails(checkData?.emails || []);
  }, [checkData]);
  return (
    <>
      <div className="hstack gap-2 justify-content-between p-2">
        <button onClick={handleAddEmail} className="updateProfile">
          Add Email
        </button>
        <button
          onClick={updateStudyLevelFieldCheckNotification}
          className="updateProfile"
          disabled={buttonLoader}
        >
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" /> Saving...
            </div>
          ) : (
            "Save Emails"
          )}
        </button>
      </div>
      <div className="p-2">
        {emails.map((email, index) => (
          <InputGroup key={index} className="mb-1" style={{ width: "35%" }}>
            <Form.Control
              type="email"
              placeholder="Enter Email"
              value={email}
              onChange={(e) => handleEmailChange(index, e.target.value)}
            />
            <button
              onClick={() => handleDeleteEmail(index)}
              className="removeProfile"
            >
              x
            </button>
          </InputGroup>
        ))}
      </div>
    </>
  );
};

export default AddEmailForNotify;
